var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.container_class }, [
    _c("div", {
      staticClass: "pane-container",
      attrs: { id: _vm.pane_container_id }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "responsive-image preview-box",
      attrs: { src: _vm.regular, "data-zoom": _vm.large, draggable: "false" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }